class FileService {
    /**
     * @param {string} fileName
     * @param {string} extension
     * @param {string} content
     * @returns
     */
    downloadContentInFile = (fileName, extension = 'txt', content = '') => {
        const url = window.URL.createObjectURL(new Blob([content]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.${extension}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
}

export default (new FileService());
